import React from 'react';
import { motion } from 'framer-motion';
import { useExperience } from '../../contexts/ExperienceContext';
import { selectionPriorities } from '../../data/journeys';
import { needById, needs } from '../../data/needs';
import { Advance } from '../ui/Advance';
import { Eyebrow, RevealText, Stage } from '../ui/Stage';
const ease = [0.16, 1, 0.3, 1] as const;

/** The "new to Filtek" pivot: one strength is never the whole week. */
export function BridgeStage() {
  const {
    signals,
    next,
    direction,
    primaryNeed
  } = useExperience();
  const choice = selectionPriorities.find(item => item.id === signals.priority) ?? selectionPriorities[0];
  const accent = needById(choice.need).accent;
  return <Stage direction={direction} className="min-h-screen py-28 sm:py-32" labelledBy="bridge-title" data-id="element-161" data-mp="17xj0bxlgdhmr">
      <div className="grid gap-14 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-center lg:gap-20" data-id="element-162" data-mp="1cwm65k99brvs">
        <div data-id="element-163" data-mp="1gwwg180672fx">
          <Eyebrow accent={accent} data-id="element-164" data-mp="1gyh7upv3o7a3">You value · {choice.label}</Eyebrow>

          <h2 id="bridge-title" className="display-tight mt-9 text-[2.1rem] font-light text-enamel sm:text-[3rem] lg:text-[3.6rem]" data-id="element-165" data-mp="1q5nsr7kss94l">
            <RevealText text="Different cases require different strengths." delay={0.25} data-id="element-166" data-mp="1l8e43u58g1ht" />
          </h2>

          <motion.p className="mt-9 max-w-xl text-lede font-light text-mute" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.9,
          delay: 1.1
        }} data-id="element-167" data-mp="1b7vdmgj5xmqx">
            <span className="capitalize text-enamel" data-id="element-168" data-mp="23w9cszlzmp42">{choice.emphasis}</span> is one of them. A
            normal week will ask for the others too — which is why Filtek is a family rather than a
            single composite.
          </motion.p>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 1.6
        }} className="mt-12" data-id="element-169" data-mp="1u4n53d8uz862">
            <Advance label="Show me what it covers" onClick={next} accent={accent} data-id="element-170" data-mp="2mu2fq1wm2z1g" />
          </motion.div>
        </div>

        {/* Strength profile: one bar per clinical demand */}
        <div className="flex h-64 items-end gap-3 sm:h-80 sm:gap-5" data-id="element-171" data-mp="pwekpx8dvtl4">
          {needs.map((need, index) => {
          const isMatch = need.id === (primaryNeed ?? choice.need);
          return <div key={need.id} className="flex h-full flex-1 flex-col justify-end gap-4" data-id="element-172" data-mp="g5jyutz1uw07" data-mpi={index}>
                <motion.div className="w-full rounded-t-sm" style={{
              backgroundColor: need.accent
            }} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: isMatch ? '100%' : `${42 + index * 9}%`,
              opacity: isMatch ? 0.85 : 0.28
            }} transition={{
              duration: 1.2,
              delay: 0.4 + index * 0.12,
              ease
            }} data-id="element-173" data-mp="25sco5ydq9b4" />
                <p className="text-[10px] font-light leading-tight text-mute sm:text-xs" style={{
              color: isMatch ? 'var(--enamel)' : undefined
            }} data-id="element-174" data-mp="1rmth5d6fzhzx">
                  {need.label}
                </p>
              </div>;
        })}
        </div>
      </div>
    </Stage>;
}